
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.395 5.875V1.5h12.21v15H7.396v-4.25h-1.5V17a1 1 0 001 1h13.21a1 1 0 001-1V1a1 1 0 00-1-1H6.896a1 1 0 00-1 1v4.875h1.5z","fill":"#748190"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.895 4.031a1 1 0 00-1 1v8a1 1 0 001 1h8.555a1 1 0 001-1v-8a1 1 0 00-1-1H1.895zm.69 6.438H3.2v-.943h.517c.67 0 1.058-.4 1.058-.98 0-.579-.382-.986-1.042-.986H2.585v2.909zM3.2 9.033v-.97h.415c.355 0 .527.193.527.482s-.172.488-.524.488H3.2zm3.006 1.436c.886 0 1.423-.549 1.423-1.458 0-.906-.537-1.451-1.414-1.451h-1.04v2.909h1.031zm-.416-.527V8.087h.392c.545 0 .834.278.834.924 0 .65-.289.93-.836.93h-.39zm2.91.527h-.615v-2.91h1.926v.508H8.7v.693h1.183v.507H8.7v1.202z","fill":"#748190"}})])
          )
        }
      }
    